<template>
    <div id="app" class="row-md-12 jumbotron text-white rounded bg-dark">
        <div class="blog-header-logo text-white text-center">Turkey Bowl Roster</div>
        <div class="container justify-content-md-center">
            <table id="players" class="table table-dark table-hover" style="margin: 0px auto;  width:100%;">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">Name</th>
                        <th scope="col">College</th>
                        <th scope="col">Height</th>
                        <th scope="col">Experience</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(player, index) in players" v-bind:key="index">
                        <td v-if="player.headshot"><img :src="require(`../assets/images/headshots/${player.headshot}`)" /></td>
                        <td v-else><img src="../assets/images/headshots/blankheadshot.png" /></td>
                        <td>{{player.first_name}} {{player.last_name}}</td>
                        <td>{{player.college}}</td>
                        <td>{{player.height}}</td>
                        <td>{{player.experience}} yrs</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Players',
    data() {
        return {
            players: {}
        }
    },
    methods: {
        fetchPlayers() {
            fetch('https://buhbq6w0mb.execute-api.us-east-2.amazonaws.com/Production/players', {
                method: 'GET'
            })
                .then(response => response.json())
                .then(json => this.players = json.data.Items)
        }
    },
    created() {
        this.fetchPlayers()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Players.vue